/**
 * Formatiert ein Datum zu 'DD.MM.YYYY'
 * @param {Date|string} date - Datum als Date-Objekt oder ISO-String
 * @returns {string} Formatiertes Datum oder Fallback
 */
export const formatDateOnly = (date) => {
  if (!date) return 'Kein Datum';

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;

    // Validierung
    if (isNaN(dateObj.getTime())) {
      return 'Ungültiges Datum';
    }

    return dateObj.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch (error) {
    console.error('Date formatting error:', error);
    return 'Fehler beim Formatieren';
  }
};

/**
 * Findet das Timestamp-Objekt für einen Step-Text
 * @param {string} stepText - Der Step-Text
 * @param {Array} stepTimestamps - Array von {text, createdAt, index}
 * @returns {Object|null} Timestamp-Objekt oder null
 */
export const findStepTimestamp = (stepText, stepTimestamps) => {
  if (!stepTimestamps || !Array.isArray(stepTimestamps)) {
    return null;
  }

  // Exakte Übereinstimmung
  return stepTimestamps.find(ts => ts.text === stepText) || null;
};
